import React, {ReactElement} from 'react';

function SectionLoader(): ReactElement {
    return (
        <h3>Loading...</h3>
    );
}

export default SectionLoader;